import { ReactNode } from 'react';

export interface PickerItem {
  id?: string;
  key?: string;
  name?: string;
  ext?: string;
  size?: string;
  createdTime?: string;
}

export function getItemId(item: PickerItem | null | undefined): string {
  if (!item) return '';
  return String(item.id ?? item.key ?? '');
}

export interface PickerColumn<T extends PickerItem = PickerItem> {
  key: string;
  header: string;
  widthClass?: string;
  render: (item: T) => ReactNode;
  searchable?: boolean;
  getSearchValue?: (item: T) => string;
}

export interface FetchItemsParams {
  limit: number;
  pageToken: string | null;
  searchQuery: string | null;
}

export interface FetchItemsResult<T extends PickerItem = PickerItem> {
  items: T[];
  nextPageToken: string | null;
  hasMore: boolean;
}

export interface ItemsPickerModalProps<T extends PickerItem = PickerItem> {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  disabled?: boolean;
  items?: T[];
  selectedIds?: string[];
  multiSelect?: boolean;
  onSaveSelected: (items: T[]) => void;
  saveLabel?: string;
  searchPlaceholder?: string;
  columns?: PickerColumn<T>[];
  onSearch?: (query: string) => void;
  isLoading?: boolean;

  // Paginated mode — when provided, the modal owns its own paging/search loop.
  fetchItems?: (params: FetchItemsParams) => Promise<FetchItemsResult<T>>;
  perPageOptions?: number[];
  defaultPerPage?: number;

  // Optional visual cue for a row that is already "attached"/saved upstream.
  savedItemId?: string | null;
  savedItemUrl?: string | null;
  savedItemLinkLabel?: string;
}
